<!-- 地图 -->
<style lang="stylus" scoped>
.center {
  height: 100%;
  padding: 5px;
  background-size: 100% 100%;

  .describe {
    display: flex;
    justify-content: space-between;
    color: #fff;
    text-align: center;
    margin-top: 3vh;
    margin-bottom: 2vh;

    .left, .right {
      width: 50%;
    }

    .title {
      width: 14.3vh;
      height: 4.2vh;
      line-height: 4.2vh;
      margin: 2vh auto;
      background: rgba(8, 26, 84, 0);
      border: 1px solid rgba(0, 96, 255, 1);
      box-shadow: inset 0px 0px 30px 0px rgba(0, 96, 255, 0.5);
      font-size: 1.8vh;
      font-weight: bold;
    }

    .detail {
      display: flex;

      .item {
        width: 100%;

        P {
          margin-bottom: 1vh;
        }

        .name {
          font-size: 1.8vh;
          font-weight: bold;
        }

        .num {
          color: #FFDD01;
          font-size: 3vh;
          font-weight: bold;

          span {
            padding-left: 0.8vh;
            font-size: 2vh;
            font-weight: 400;
            color: #fff;
          }
        }

        .percent {
          font-size: 1.6vh;
          font-weight: 400;
          color: #EF850E;

          &:after {
            display: inline-block;
            content: '';
            width: 1vh;
            height: 1.1vh;
            margin-left: 0.5vh;
          }
        }

        .percent1 {
          font-size: 1.6vh;
          font-weight: 400;
          color: #EF850E;

          &:after {
            display: inline-block;
            content: '';
            width: 1vh;
            height: 1.1vh;
            margin-left: 0.5vh;
            // background url('../../../../../static/img/dashboard/down_icon.png')
          }
        }
      }
    }
  }

  .map {
    width: 100%;
    height: 62.5vh;
    position: relative;
    margin: 0 auto;
    background: url('../../../../../assets/img/dashboard/map.png');
    background-size: 100% 100%;

    .leftMassif .rateHalf .content .product-image-0 {
      position: absolute;
      top: 14.5% !important;
    }

    .leftMassif .rateHalf .content .productImage {
      width: 35%;
      height: 10px !important;
    }

    .leftMassif .rateHalf .content .product-image-1 {
      position: absolute;
      top: 61.5% !important;
    }

    .tip {
      position: absolute;
      left: 10%;
      top: 10%;
      height: auto;
      z-index: 999;
      width: 28.6vh;
      height: 14.7vh;

      ul {
        width: 25.7vh;
        height: auto;
        min-height: 16vh;
        float: left;
        background: url('../../../../../assets/img/dashboard/tip.png');
        background-size: 100% 100%;

        li {
          width: 25.7vh;
          list-style: none;
          color: #FFf;
          line-height: 1.9vh;
          padding-left: 3vh;
          font-size: 1.4vh;
          // white-space: nowrap;
          // text-overflow: ellipsis;
          // overflow: hidden;
        }

        li:nth-child(1) {
          line-height: 6.5vh;
          font-size: 1.6vh;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #20f7f6;
          height: 5vh;
          padding-left: 3vh;
        }
      }
    }

    .right {
      width: 200px;
      height: 600px;
      background: red;
      float: right;
      transform: rotate(-20deg);

      ul {
        li {
          width: 106px;
          height: 30px;
          background: rgba(14, 75, 159, 1);
          border: 1px solid rgba(143, 243, 255, 0.73);
          text-align: center;
          line-height: 30px;
          color: #FFf;
        }
      }
    }
  }
}
</style>

<template>
  <div>
    <div class="center">
      <div class="describe">
        <div class="left">
          <div class="title">总产值</div>
          <div class="detail">
            <div class="item">
              <p class="num">{{ this.outputValue }}<span>万元</span></p>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="title">生产规模</div>
          <div class="detail">
            <div class="item">
              <p class="num">{{ this.productionScale }}<span>亩</span></p>
            </div>
          </div>
        </div>
      </div>
      <div class="map">
        <div class="tip" v-show="tip" @mouseenter="tips" @mouseleave="leave()">
          <ul v-for="(item, index) in list" v-if="index < 1">
            <li>大棚数据</li>
            <li>{{ item.massIfName }}</li>
            <li>{{ item.traceBatchName }}</li>

            <template v-if="item.hasHarvest == 1 && item.harvestQuantity > 0">
              <li>已采收</li>
              <li>采收质量{{ item.harvestQuantity }}斤</li>
            </template>
            <li v-else-if="item.expectQuantity > 0">预计产量{{ item.expectQuantity }}斤</li>
            <li v-else-if="item.toHarvestDays >= 1">距离采收还有{{ item.toHarvestDays }}天</li>

            <!-- {data.traceBatchName && <div>{data.traceBatchName}</div>}
          {data.expectQuantity > 0 && <div className={styles.text}>预计产量{data.expectQuantity}斤</div>}
          {data.toHarvestDays && data.toHarvestDays >= 0 && <div className={styles.text}>距离采收还有{data.toHarvestDays}天</div>}
           -->
          </ul>
        </div>
        <div class="leftMassif">
          <!-- <div class="theme-1 theme-index-0  theme-index-0___uF0Ow massifItem" title="D10">
            <div class="content"><div class="empty">可用</div></div>
          </div>
          <div class="theme-1 theme-index-1  theme-index-1___1pA8O massifItem" title="D09">
            <div class="content"><div class="empty">可用</div></div>
          </div>
          <div class="theme-1 theme-index-2  theme-index-2___3DSIl massifItem" title="D08">
            <div class="content"><div class="empty">可用</div></div>
          </div>
          <div class="theme-1 theme-index-3  theme-index-3___1a1vb massifItem" title="D07">
            <div class="content"><div class="empty">可用</div></div>
          </div>
          <div class="theme-1 theme-index-4  theme-index-4___tpSz_ massifItem" title="D06">
            <div class="content"><div class="empty">可用</div></div>
          </div>
          <div class="theme-1 theme-index-5  theme-index-5___23JXZ massifItem" title="D05">
            <div class="content"><div class="empty">可用</div></div>
          </div>
          <div class="theme-1 theme-index-6  theme-index-6___MA5i8 massifItem" title="D04">
            <div class="content"><div class="empty">可用</div></div>
          </div>
          <div class="theme-1 theme-index-7  theme-index-7___1VFZT massifItem" title="D03">
            <div class="content"><div class="empty">可用</div></div>
          </div> -->

          <div :key="index" :class="`theme-${item.theme}  theme-index-${item.index}  massifItem ${item.list.length > 1 ? 'rateHalf' : ''} `" v-for="(item, index) in massifList" :title="item.name">
            <div class="content" v-if="item.list.length > 0" @click="show(item.list, '1')" @mouseenter="show(item.list, '1')" @mouseleave="leave()">
              <div v-for="(data, dataindex) in item.list">
                <div :key="`${dataindex}${data.productUrl}`" :class="`rate rate-${dataindex}`" :style="`width:${data.progressRate > 1 ? 100 : data.progressRate * 100}%`"></div>
                <img v-if="data.productUrl" :key="`${data.productUrl}`" :class="`productImage product-image-${dataindex}`" :src="`${url}${data.productUrl}`" />
              </div>
            </div>
            <div v-else class="empty"></div>
          </div>
        </div>
        <div class="rightMassif">
          <div :key="index" :class="`${item.list.length > 1 ? 'rateHalf' : ''} ${item.theme === null ? 'disabled' : ''}  `" class="massifItem" v-for="(item, index) in massifListR" :title="item.name">
            <div v-if="item.list.length > 0" @click="show(item.list, '1')" @mouseenter="show(item.list, '1')" @mouseleave="leave()">
              <template v-for="(data, dataindex) in item.list">
                <div :class="`rate rate-${dataindex}`" :style="`width:${data.progressRate > 1 ? 100 : data.progressRate * 100}%`"></div>
                <img v-if="data.productUrl" :class="`productImage product-image-${dataindex}`" :src="`${url}${data.productUrl}`" />
              </template>
            </div>
            <div v-else class="empty">可用</div>
          </div>
        </div>
      </div>
      <!-- <centerBottom></centerBottom> -->
    </div>
  </div>
</template>

<script>
import config from '../../../../../../static/config/config';
import centerBottom from './centerBottom'
import './LeftMassif/index.css'
import './LeftMassif/MassifItem/index.css'

import './RightMassif/index.less'
import './RightMassif/MassifItem/index.less'

class MassifItem {
  list = [];
  type = 'left';

  constructor(theme, text = '', name = '', index) {
    this.theme = theme;
    this.text = text;
    this.name = name;
    this.index = index
  }

  setMassif(massif) {
    this.massif = massif;
    return this;
  }

  setList(list) {
    this.list = list;
    return this;
  }

  getStyle() {
    const style = {};
    return style;
  }

  getThemeIndex() {
    return this.list.filter(item => {
      return item.theme === this.theme;
    }).indexOf(this);
  }

  getClassName() {
    const themeIndex = this.getThemeIndex();
    return classNames(
      `theme-${this.theme}`,
      `theme-index-${themeIndex}`
    );
  }
}
const list = [
  new MassifItem(1, '', 'D10', 0),
  new MassifItem(1, '', 'D09', 1),
  new MassifItem(1, '', 'D08', 2),
  new MassifItem(1, '', 'D07', 3),
  new MassifItem(1, '', 'D06', 4),
  new MassifItem(1, '', 'D05', 5),
  new MassifItem(1, '', 'D04', 6),
  new MassifItem(1, '', 'D03', 7),
  new MassifItem(1, '', 'D02', 8),
  new MassifItem(1, '', 'D01', 9),
  //
  new MassifItem(2, '', '16-1', 0),
  new MassifItem(2, '', '16-3', 1),
  new MassifItem(2, '', '16-5', 2),
  new MassifItem(2, '', '16-7', 3),
  new MassifItem(2, '', '16-9', 4),
  new MassifItem(2, '', '16-11', 5),
  new MassifItem(2, '', '16-2', 6),
  new MassifItem(2, '', '16-4', 7),
  new MassifItem(2, '', '16-6', 8),
  new MassifItem(2, '', '16-8', 9),
  new MassifItem(2, '', '16-10', 10),
  new MassifItem(2, '', '16-12', 11),
  //
  new MassifItem(3, '', '', 0),
  new MassifItem(3, '', '', 1),
  //
  new MassifItem(4, '15', '15号棚', 0),
  new MassifItem(5, '', '', 1),
  //
  new MassifItem(6, '', '14号棚', 0),
  new MassifItem(6, '', '13号棚', 1),
  //
  new MassifItem(7, '', '12号棚', 1),
  new MassifItem(8, '', '11号棚', 0),
  new MassifItem(8, '', '9号棚', 1),
  new MassifItem(8, '', '3号棚', 2),
  new MassifItem(8, '', '8号棚', 3),
  new MassifItem(8, '', '2号棚', 4),
  new MassifItem(8, '', '7号棚', 5),
  new MassifItem(8, '', '1号棚', 6),
  //
  new MassifItem(9, '', '10号棚', 0),
  new MassifItem(10, '', '', 1),
  //
  new MassifItem(11, '', '6号棚', 0),
  new MassifItem(11, '', '5号棚', 1),
  new MassifItem(11, '', '4号棚', 2),
  //
  new MassifItem(12, '', '', 0),
  new MassifItem(13, '', '', 1),
  new MassifItem(14, '', '', 2),
  //
  new MassifItem(15, '', '展-2A', 0),
  new MassifItem(15, '', '展-2C', 1),
  //
  new MassifItem(16, '', '展-2B', 0),
  new MassifItem(16, '', '展-2D', 1),
  //
  new MassifItem(17, '', '展-叶菜区', 0),
  new MassifItem(17, '', '展-叶菜区', 1)
];
const rightlist = [
  new MassifItem(null),
  new MassifItem(15, '15', '581-15'),
  new MassifItem(16, '16', '581-16'),
  new MassifItem(14, '14', '581-14'),
  new MassifItem(17, '17', '581-17'),
  new MassifItem(13, '13', '581-13'),
  new MassifItem(18, '18', '581-18'),
  new MassifItem(12, '12', '581-12'),
  new MassifItem(19, '19', '581-19'),
  new MassifItem(11, '11', '581-11'),
  new MassifItem(20, '20', '581-20'),
  new MassifItem(10, '10', '581-10'),
  new MassifItem(21, '21', '581-21'),
  new MassifItem(9, '9', '581-9'),
  new MassifItem(22, '22', '581-22'),
  new MassifItem(8, '8', '581-8'),
  new MassifItem(23, '23', '581-23'),
  new MassifItem(7, '7', '581-7'),
  new MassifItem(24, '24', '581-24'),
  new MassifItem(6, '6', '581-6'),
  new MassifItem(25, '25', '581-25'),
  new MassifItem(5, '5', '581-5'),
  new MassifItem(26, '26', '581-26'),
  new MassifItem(4, '4', '581-4'),
  new MassifItem(27, '27', '581-27'),
  new MassifItem(3, '3', '581-3'),
  new MassifItem(28, '28', '581-28'),
  new MassifItem(2, '2', '581-2'),
  new MassifItem(29, '29', '581-29'),
  new MassifItem(1, '1', '581-1')
];

export default {
  props: ["productionScale", "outputValue"],
  data() {
    return {
      areaName: '',
      timer: null,
      massifList: [],
      massifListR: [],
      tip: true,
      list: [],
      datalist: [],
      index: 0,
      url: config.fileDomain
    }
  },
  components: {
    centerBottom
  },
  methods: {
    show(val, type) {
      // console.log(type === '1')
      if (type === '1') {
        clearInterval(this.timer);
      }
      this.tip = true
      this.list = val
    },
    tips() {
      clearInterval(this.timer);
      this.tip = true
    },
    leave() {
      this.tip = false;
      this.time()
    },
    time() {
      var count = this.datalist.length
      this.timer = setInterval(() => {
        if (this.index > count) {
          this.index = 0
        }
        this.show(this.datalist[this.index])
        this.index = this.index + 1
        // console.log(this.index)
      }, 3000);
    }
  },
  async mounted() {
    let { err, res } = await this.$model('dataManagement').commonfn2(this.$apiUrl.DATAANALYSIS.GetMassIfInfoStatistic);
    if (res.state === 200) {
      let resultData = res.results
      resultData = {
        "10号棚": [{
          "massIfName": "10号棚",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "4488.0",
          "hasHarvest": 0,
          "massId": "5da6b24187944a778a1e1867c8757923",
          "areaUnitName": "平方米",
          "partitionName": "老园区",
          "massAreaVal": 4488
        }],
        "12号棚": [{
          "massIfName": "12号棚",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "1824.0",
          "hasHarvest": 0,
          "massId": "7f458d2a56d6428ea205bf60806e6c14",
          "areaUnitName": "平方米",
          "partitionName": "老园区",
          "massAreaVal": 1824
        }],
        "13号棚": [{
          "massIfName": "13号棚",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "1152.0",
          "hasHarvest": 0,
          "massId": "6161573284224bab92fd36ae41dc6e03",
          "areaUnitName": "平方米",
          "partitionName": "老园区",
          "massAreaVal": 1152
        }],
        "14号棚": [{
          "massIfName": "14号棚",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "1152.0",
          "hasHarvest": 0,
          "massId": "5adcad3d40b143ada96b2624a88b75dd",
          "areaUnitName": "平方米",
          "partitionName": "老园区",
          "massAreaVal": 1152
        }],
        "15号棚": [{
          "massIfName": "15号棚",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "960.0",
          "hasHarvest": 0,
          "massId": "405421605f8242ffbeca94ed87f76bcb",
          "areaUnitName": "平方米",
          "partitionName": "老园区",
          "massAreaVal": 960
        }],
        "16-1": [{
          "massIfName": "16-1",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "黄德振",
          "massArea": "5960.0",
          "traceBatchName": "美月西瓜_16-1_20190822",
          "toHarvestDays": "-2",
          "hasHarvest": 0,
          "progressRate": 1.027027,
          "productUrl": "7efa1db47ccd499a83413377beb70431",
          "traceBatchInfoId": "4998b975ed0b47428978bb0d93bd9c74",
          "productName": "美月西瓜",
          "startDate": "2019-08-22",
          "harvestQuantity": 64360,
          "harvestDamagedQuantity": 734,
          "massId": "628654838b564fc381d56e06f8072862",
          "productId": "0b2d4ee67c984d838cea64bafb64179d",
          "harvestDate": "2019-11-04",
          "areaUnitName": "平方米",
          "partitionName": "中荷温室",
          "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-08-22 19:48:30",
          "harvestCreateTime": 1572861140941,
          "id": 186,
          "massAreaVal": 5960
        }],
        "16-10": [{
          "massIfName": "16-10",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "黄德振",
          "massArea": "5636.0",
          "traceBatchName": "美月西瓜_16-10_20191015",
          "toHarvestDays": "51",
          "hasHarvest": 0,
          "progressRate": 0.32,
          "productUrl": "7efa1db47ccd499a83413377beb70431",
          "traceBatchInfoId": "949082d39cc7401e8cab70ca79004657",
          "productName": "美月西瓜",
          "startDate": "2019-10-13",
          "massId": "06b9818a3a344d1cb98f5ece106d7139",
          "productId": "0b2d4ee67c984d838cea64bafb64179d",
          "areaUnitName": "平方米",
          "partitionName": "中荷温室",
          "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-10-15 16:13:11",
          "id": 332,
          "massAreaVal": 5636
        }, {
          "massIfName": "16-10",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "黄德振",
          "massArea": "5636.0",
          "traceBatchName": "美月西瓜_16-10_20190902",
          "toHarvestDays": "0",
          "hasHarvest": 1,
          "progressRate": 1,
          "productUrl": "7efa1db47ccd499a83413377beb70431",
          "traceBatchInfoId": "eb48887da2f8465d824659afb42fb3dc",
          "productName": "美月西瓜",
          "startDate": "2019-08-06",
          "harvestQuantity": 14883,
          "harvestDamagedQuantity": 140,
          "massId": "06b9818a3a344d1cb98f5ece106d7139",
          "productId": "0b2d4ee67c984d838cea64bafb64179d",
          "harvestDate": "2019-10-12",
          "areaUnitName": "平方米",
          "partitionName": "中荷温室",
          "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 2,
          "createTime": "2019-09-02 23:44:45",
          "harvestCreateTime": 1571129662779,
          "id": 226,
          "massAreaVal": 5636
        }],
        "16-11": [{
          "massIfName": "16-11",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "黄德振",
          "massArea": "7152.0",
          "traceBatchName": "美月西瓜_16-11_20190904",
          "toHarvestDays": "11",
          "hasHarvest": 0,
          "progressRate": 0.8513514,
          "productUrl": "7efa1db47ccd499a83413377beb70431",
          "traceBatchInfoId": "a339cbf54b2e430aa04297689118a07a",
          "productName": "美月西瓜",
          "startDate": "2019-09-04",
          "massId": "caf0c5e5f500424aab26b66a4b01d2fb",
          "productId": "0b2d4ee67c984d838cea64bafb64179d",
          "areaUnitName": "平方米",
          "partitionName": "中荷温室",
          "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-09-04 21:52:36",
          "id": 234,
          "massAreaVal": 7152
        }],
        "16-12": [{
          "massIfName": "16-12",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "黄德振",
          "massArea": "6768.0",
          "traceBatchName": "美月西瓜_16-12_20190924",
          "toHarvestDays": "24",
          "hasHarvest": 0,
          "progressRate": 0.6712329,
          "productUrl": "7efa1db47ccd499a83413377beb70431",
          "traceBatchInfoId": "7f87f62dab0540d7b275cb405b9c5788",
          "productName": "美月西瓜",
          "startDate": "2019-09-18",
          "massId": "b84e9c0106d64227ab51a2e34e98d1cf",
          "productId": "0b2d4ee67c984d838cea64bafb64179d",
          "areaUnitName": "平方米",
          "partitionName": "中荷温室",
          "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-09-24 15:00:59",
          "id": 300,
          "massAreaVal": 6768
        }],
        "16-2": [{
          "massIfName": "16-2",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "黄德振",
          "massArea": "5640.0",
          "traceBatchName": "美月西瓜_16-2_20190818",
          "toHarvestDays": "-8",
          "hasHarvest": 0,
          "progressRate": 1.1111112,
          "productUrl": "7efa1db47ccd499a83413377beb70431",
          "traceBatchInfoId": "1d6b950c60f14f87a85587c76aec6056",
          "productName": "美月西瓜",
          "startDate": "2019-08-18",
          "massId": "30596634280f4c88a320ef3dd911c41b",
          "productId": "0b2d4ee67c984d838cea64bafb64179d",
          "areaUnitName": "平方米",
          "partitionName": "中荷温室",
          "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-08-18 21:58:05",
          "id": 183,
          "massAreaVal": 5640
        }],
        "16-3": [{
          "massIfName": "16-3",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "黄德振",
          "massArea": "5960.0",
          "traceBatchName": "美月西瓜_16-3_20190826",
          "toHarvestDays": "-66",
          "hasHarvest": 0,
          "progressRate": 12,
          "productUrl": "7efa1db47ccd499a83413377beb70431",
          "traceBatchInfoId": "f48f9b325b734ddfa9b187aedb7d21e9",
          "productName": "美月西瓜",
          "startDate": "2019-08-26",
          "massId": "b2bc1a0be0e84abe9a90f52ed90e5e1b",
          "productId": "0b2d4ee67c984d838cea64bafb64179d",
          "areaUnitName": "平方米",
          "partitionName": "中荷温室",
          "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-08-26 22:14:39",
          "id": 189,
          "massAreaVal": 5960
        }],
        "16-4": [{
          "massIfName": "16-4",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "黄德振",
          "massArea": "5640.0",
          "traceBatchName": "美月西瓜_16-4_20190831",
          "toHarvestDays": "6",
          "hasHarvest": 0,
          "progressRate": 0.91780823,
          "productUrl": "7efa1db47ccd499a83413377beb70431",
          "traceBatchInfoId": "69e05d8245014c2d9d0a84ec694bd5e6",
          "productName": "美月西瓜",
          "startDate": "2019-08-31",
          "massId": "8095b224d21c469681b3adebbc2639b2",
          "productId": "0b2d4ee67c984d838cea64bafb64179d",
          "areaUnitName": "平方米",
          "partitionName": "中荷温室",
          "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-08-31 19:59:52",
          "id": 217,
          "massAreaVal": 5640
        }],
        "16-5": [{
          "massIfName": "16-5",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "黄德振",
          "massArea": "5960.0",
          "traceBatchName": "美月西瓜_16-5_20190923",
          "toHarvestDays": "3",
          "hasHarvest": 0,
          "progressRate": 0.95454544,
          "productUrl": "7efa1db47ccd499a83413377beb70431",
          "traceBatchInfoId": "83da26865fa441799bad62ac5958a975",
          "productName": "美月西瓜",
          "startDate": "2019-09-04",
          "massId": "f53c67ab0b484dcea2c0d6a397828200",
          "productId": "0b2d4ee67c984d838cea64bafb64179d",
          "areaUnitName": "平方米",
          "partitionName": "中荷温室",
          "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-09-23 21:15:05",
          "id": 296,
          "massAreaVal": 5960
        }],
        "16-6": [{
          "massIfName": "16-6",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "黄德振",
          "massArea": "5462.0",
          "hasHarvest": 0,
          "massId": "66afdfa9d0c94ebe942d02682354c218",
          "areaUnitName": "平方米",
          "partitionName": "中荷温室",
          "massAreaVal": 5462
        }],
        "16-7": [{
          "massIfName": "16-7",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "黄德振",
          "massArea": "6536.0",
          "traceBatchName": "美月西瓜_16-7_20191012",
          "toHarvestDays": "40",
          "hasHarvest": 0,
          "progressRate": 0.4520548,
          "productUrl": "7efa1db47ccd499a83413377beb70431",
          "traceBatchInfoId": "1984f8d59c2f4359979dff923e49071c",
          "productName": "美月西瓜",
          "startDate": "2019-10-04",
          "massId": "ffb9b8a7890e449bbfbec5326a4d2a26",
          "productId": "0b2d4ee67c984d838cea64bafb64179d",
          "areaUnitName": "平方米",
          "partitionName": "中荷温室",
          "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-10-12 12:08:40",
          "id": 319,
          "massAreaVal": 6536
        }],
        "16-8": [{
          "massIfName": "16-8",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "黄德振",
          "massArea": "6203.0",
          "hasHarvest": 0,
          "massId": "7932fe634ff84135bf616c3665171bd0",
          "areaUnitName": "平方米",
          "partitionName": "中荷温室",
          "massAreaVal": 6203
        }],
        "16-9": [{
          "massIfName": "16-9",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "黄德振",
          "massArea": "5736.0",
          "traceBatchName": "美月西瓜_16-9_20190902",
          "toHarvestDays": "0",
          "hasHarvest": 1,
          "progressRate": 1,
          "productUrl": "7efa1db47ccd499a83413377beb70431",
          "traceBatchInfoId": "580db7cc3761457183af7b0be3fc0911",
          "productName": "美月西瓜",
          "startDate": "2019-08-13",
          "harvestQuantity": 13147,
          "harvestDamagedQuantity": 15,
          "massId": "56a5fbb4f6b641daa0d56bae99261067",
          "productId": "0b2d4ee67c984d838cea64bafb64179d",
          "harvestDate": "2019-10-21",
          "areaUnitName": "平方米",
          "partitionName": "中荷温室",
          "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 2,
          "createTime": "2019-09-02 23:45:56",
          "harvestCreateTime": 1571828586702,
          "id": 227,
          "massAreaVal": 5736
        }],
        "1号棚": [{
          "massIfName": "1号棚",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "3840.0",
          "hasHarvest": 0,
          "massId": "82a7d7497b2c480a8588ae633ed1fed5",
          "areaUnitName": "平方米",
          "partitionName": "老园区",
          "massAreaVal": 3840
        }],
        "2号棚": [{
          "massIfName": "2号棚",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "3840.0",
          "hasHarvest": 0,
          "massId": "b648e2e829144d4d88db432519d3f0ca",
          "areaUnitName": "平方米",
          "partitionName": "老园区",
          "massAreaVal": 3840
        }],
        "3号棚": [{
          "massIfName": "3号棚",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "3840.0",
          "hasHarvest": 0,
          "massId": "60e1a5484b4e4185a6f84b413ec0123e",
          "areaUnitName": "平方米",
          "partitionName": "老园区",
          "massAreaVal": 3840
        }],
        "4号棚": [{
          "massIfName": "4号棚",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "960.0",
          "hasHarvest": 0,
          "massId": "e0121eb1b20249f5a4f1921689f0f4b8",
          "areaUnitName": "平方米",
          "partitionName": "老园区",
          "massAreaVal": 960
        }],
        "581-1": [{
          "massIfName": "581-1",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6080.0",
          "traceBatchName": "美月西瓜_581-1_20190908",
          "toHarvestDays": "0",
          "hasHarvest": 1,
          "progressRate": 1,
          "productUrl": "7efa1db47ccd499a83413377beb70431",
          "traceBatchInfoId": "4803bec142df4c7c8b81344f14385969",
          "productName": "美月西瓜",
          "harvestQuantity": 17198,
          "harvestDamagedQuantity": 250,
          "massId": "a71183836d634425be34001674d28011",
          "productId": "0b2d4ee67c984d838cea64bafb64179d",
          "harvestDate": "2019-10-22",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 2,
          "createTime": "2019-09-08 19:08:26",
          "harvestCreateTime": 1571736980512,
          "id": 245,
          "massAreaVal": 6080
        }],
        "581-10": [{
          "massIfName": "581-10",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6080.0",
          "hasHarvest": 0,
          "massId": "70fa77f342484e448b043fea4f15807b",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6080
        }],
        "581-11": [{
          "massIfName": "581-11",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "da7ea37570f6457da4b7ea57b3ba7a0e",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-12": [{
          "massIfName": "581-12",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "649cf669ea50497abf0e2d654a5a0394",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-13": [{
          "massIfName": "581-13",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "192737df21064002a87b1a900330a822",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-14": [{
          "massIfName": "581-14",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "8901900a1de14e619baa1657e10c12b6",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-15": [{
          "massIfName": "581-15",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "1632a87c41264b449c2c2c50308780bd",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-16": [{
          "massIfName": "581-16",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "43600f01a840498fa87358e1db1ad723",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-17": [{
          "massIfName": "581-17",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "0767994c6c944a568fea24452a78503a",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-18": [{
          "massIfName": "581-18",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "6499f5114e32433f883f70b09be18911",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-19": [{
          "massIfName": "581-19",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "13d7b6c1471c49b0820234d8aadba8c8",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-2": [{
          "massIfName": "581-2",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "traceBatchName": "美月西瓜_581-2_20190930",
          "hasHarvest": 0,
          "productUrl": "7efa1db47ccd499a83413377beb70431",
          "traceBatchInfoId": "279c211d544a42d9ba77ace6ddbfe1b0",
          "productName": "美月西瓜",
          "startDate": "2019-09-27",
          "massId": "1f959a5d82604b0da975f6002472ae24",
          "productId": "0b2d4ee67c984d838cea64bafb64179d",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-09-30 20:26:21",
          "id": 315,
          "massAreaVal": 6688
        }],
        "581-20": [{
          "massIfName": "581-20",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "7a570059e21844999df90b76ed0e2cbe",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-21": [{
          "massIfName": "581-21",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "ec30417d2aae4d62ba13b1d9ed8e641d",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-22": [{
          "massIfName": "581-22",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "5ffdd43db13a4fa3aa042f8f7c043430",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-23": [{
          "massIfName": "581-23",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "cfdd0c990e1a478fbcbaf8ae60dfe231",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-24": [{
          "massIfName": "581-24",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "c85f7ce299984c0ab29d4150b78a0645",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-25": [{
          "massIfName": "581-25",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "8cb7080522154bb5a13c2e4f957ddec7",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-26": [{
          "massIfName": "581-26",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "0a9bb5a9581946ee965c49cbb29263c5",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-27": [{
          "massIfName": "581-27",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "11fe60cbd69d4ed2994386199ca425ec",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-28": [{
          "massIfName": "581-28",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "traceBatchName": "美月西瓜_581-28_20190923",
          "hasHarvest": 0,
          "productUrl": "7efa1db47ccd499a83413377beb70431",
          "traceBatchInfoId": "4ae35cea0e784b4f92cf5e3d6aaf88ea",
          "productName": "美月西瓜",
          "massId": "4d4f35f175dd4942ac698497cf409b00",
          "productId": "0b2d4ee67c984d838cea64bafb64179d",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-09-23 21:49:26",
          "id": 297,
          "massAreaVal": 6688
        }],
        "581-29": [{
          "massIfName": "581-29",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "林鸿图",
          "massArea": "2816.0",
          "hasHarvest": 0,
          "massId": "809cdd4e59214c97b524abdb2b6aac64",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 2816
        }],
        "581-3": [{
          "massIfName": "581-3",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "29ec59c9be394d298e464d919a5268e3",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-4": [{
          "massIfName": "581-4",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "traceBatchName": "千禧圣女果_581-4_20191012",
          "hasHarvest": 0,
          "productUrl": "aafefdaa8f8a488c8f8a09a92252bdbd",
          "traceBatchInfoId": "70fb136d8a1a42119a62263c7a60627d",
          "productName": "千禧圣女果",
          "startDate": "2019-09-23",
          "massId": "70804d660171419e94de93509a066c1f",
          "productId": "5648db043ce64be28d3f8c30f8876164",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-10-12 12:25:47",
          "id": 322,
          "massAreaVal": 6688
        }],
        "581-5": [{
          "massIfName": "581-5",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6080.0",
          "traceBatchName": "千禧圣女果_581-5_20191012",
          "hasHarvest": 0,
          "productUrl": "aafefdaa8f8a488c8f8a09a92252bdbd",
          "traceBatchInfoId": "cbab910912b74999aa4eff71fedee332",
          "productName": "千禧圣女果",
          "startDate": "2019-09-24",
          "massId": "1eef15f5af1547d4b335ecd3920ccde0",
          "productId": "5648db043ce64be28d3f8c30f8876164",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-10-12 12:27:03",
          "id": 323,
          "massAreaVal": 6080
        }],
        "581-6": [{
          "massIfName": "581-6",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "traceBatchName": "美月西瓜_581-6_20190930",
          "toHarvestDays": "14",
          "hasHarvest": 0,
          "progressRate": 0.7307692,
          "productUrl": "7efa1db47ccd499a83413377beb70431",
          "traceBatchInfoId": "7163ead1d62e425f964da3633ea6b121",
          "productName": "美月西瓜",
          "startDate": "2019-09-29",
          "massId": "3d2d32ca91004bf98d3745d3e33bf728",
          "productId": "0b2d4ee67c984d838cea64bafb64179d",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-09-30 20:27:21",
          "id": 316,
          "massAreaVal": 6688
        }],
        "581-7": [{
          "massIfName": "581-7",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "traceBatchName": "美月西瓜_581-7_20190825",
          "toHarvestDays": "-21",
          "hasHarvest": 0,
          "progressRate": 1.4038461,
          "productUrl": "7efa1db47ccd499a83413377beb70431",
          "traceBatchInfoId": "cf0b69f5402e4d5992b08f156e7b7490",
          "productName": "美月西瓜",
          "startDate": "2019-08-25",
          "massId": "80ee7363d44e4d4a92f2d629521ad4dd",
          "productId": "0b2d4ee67c984d838cea64bafb64179d",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-08-25 22:34:36",
          "id": 188,
          "massAreaVal": 6688
        }],
        "581-8": [{
          "massIfName": "581-8",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "589a973f7b114735a322b6604f86caf4",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-9": [{
          "massIfName": "581-9",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "21ad8dbaddd34a479b899d4f0714ef44",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "5号棚": [{
          "massIfName": "5号棚",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "960.0",
          "hasHarvest": 0,
          "massId": "6cd116f8f77a455c8017db42df934b10",
          "areaUnitName": "平方米",
          "partitionName": "老园区",
          "massAreaVal": 960
        }],
        "6号棚": [{
          "massIfName": "6号棚",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "960.0",
          "hasHarvest": 0,
          "massId": "9c458864d4404387bf9a77664bb5059b",
          "areaUnitName": "平方米",
          "partitionName": "老园区",
          "massAreaVal": 960
        }],
        "7号棚": [{
          "massIfName": "7号棚",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "3456.0",
          "hasHarvest": 0,
          "massId": "65df5b086e1b4e7b84909f49d3068c9b",
          "areaUnitName": "平方米",
          "partitionName": "老园区",
          "massAreaVal": 3456
        }],
        "8号棚": [{
          "massIfName": "8号棚",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "3456.0",
          "hasHarvest": 0,
          "massId": "dc03b56080c3499982395b2d52b23a7c",
          "areaUnitName": "平方米",
          "partitionName": "老园区",
          "massAreaVal": 3456
        }],
        "9号棚": [{
          "massIfName": "9号棚",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "3456.0",
          "hasHarvest": 0,
          "massId": "34534f5a1d344e4aadefa38cc1090154",
          "areaUnitName": "平方米",
          "partitionName": "老园区",
          "massAreaVal": 3456
        }],
        "D0": [{
          "massIfName": "D0",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "0.38",
          "traceBatchName": "辣木_D0_20191017",
          "toHarvestDays": "827",
          "hasHarvest": 0,
          "progressRate": 0.045034643,
          "productUrl": "784bd0037268432a94587ce223230b39",
          "traceBatchInfoId": "332dd859a6654339959e881eee499dad",
          "productName": "辣木",
          "startDate": "2019-09-28",
          "massId": "b20cf9abd0fc458c8465783005bb9ecd",
          "productId": "f0465ccbd45d46ecb8f1c39bf6e6369e",
          "areaUnitName": "亩",
          "partitionName": "单体棚",
          "partitionId": "23c5a2eec0104bf082047c61b6920c06",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-10-17 16:37:25",
          "id": 333,
          "massAreaVal": 0.38
        }],
        "D1": [{
          "massIfName": "D1",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "0.38",
          "traceBatchName": "美月西瓜_D1_20191018",
          "toHarvestDays": "22",
          "hasHarvest": 0,
          "progressRate": 0.6393443,
          "productUrl": "7efa1db47ccd499a83413377beb70431",
          "traceBatchInfoId": "5595473d29d94e4fb47c8a3153bd3160",
          "productName": "美月西瓜",
          "startDate": "2019-09-28",
          "massId": "6c75b19a5f63487bbadf93dc843a1e1f",
          "productId": "0b2d4ee67c984d838cea64bafb64179d",
          "areaUnitName": "亩",
          "partitionName": "单体棚",
          "partitionId": "23c5a2eec0104bf082047c61b6920c06",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-10-18 12:10:53",
          "id": 353,
          "massAreaVal": 0.38
        }],
        "D10": [{
          "massIfName": "D10",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "0.38",
          "traceBatchName": "试验圣女果_D10_20191017",
          "toHarvestDays": "120",
          "hasHarvest": 0,
          "progressRate": 0.31034482,
          "productUrl": "46676e2a1ef84a128d3c4d1e731ca8f5",
          "traceBatchInfoId": "afd7d2d3cd6d452ba674a5b35dada11c",
          "productName": "试验圣女果",
          "startDate": "2019-09-13",
          "massId": "92dc3b5740db43c7874ea0b8a1d832af",
          "productId": "91244f69d44341739cf6c175cbfb00f8",
          "areaUnitName": "亩",
          "partitionName": "单体棚",
          "partitionId": "23c5a2eec0104bf082047c61b6920c06",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-10-17 16:47:21",
          "id": 338,
          "massAreaVal": 0.38
        }],
        "D2": [{
          "massIfName": "D2",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "0.38",
          "hasHarvest": 0,
          "massId": "14c6ba17c4b54cdb96e8cd70071c0a92",
          "areaUnitName": "亩",
          "partitionName": "单体棚",
          "massAreaVal": 0.38
        }],
        "D3": [{
          "massIfName": "D3",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "0.38",
          "hasHarvest": 0,
          "massId": "1cfef5a003534d8fb9f0e1dd1a9ce0cb",
          "areaUnitName": "亩",
          "partitionName": "单体棚",
          "massAreaVal": 0.38
        }],
        "D4": [{
          "massIfName": "D4",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "0.38",
          "hasHarvest": 0,
          "massId": "b3a406d6d5f64d27a91c9ac737877a4d",
          "areaUnitName": "亩",
          "partitionName": "单体棚",
          "massAreaVal": 0.38
        }],
        "D5": [{
          "massIfName": "D5",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "0.38",
          "traceBatchName": "试验西瓜_D5_20191017",
          "toHarvestDays": "21",
          "hasHarvest": 0,
          "progressRate": 0.6557377,
          "productUrl": "95800dc2c0a941f18af50325dc571bfc",
          "traceBatchInfoId": "2aaaf3d574d0420f8ef93ad9c7809c82",
          "productName": "试验西瓜",
          "startDate": "2019-09-27",
          "massId": "5d12c9b3ec154568ba17aca75394a58f",
          "productId": "1d93f82fb76d4418bd2a5da1de452506",
          "areaUnitName": "亩",
          "partitionName": "单体棚",
          "partitionId": "23c5a2eec0104bf082047c61b6920c06",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-10-17 16:57:20",
          "id": 339,
          "massAreaVal": 0.38
        }],
        "D6": [{
          "massIfName": "D6",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "0.38",
          "traceBatchName": "试验西瓜_D6_20191017",
          "toHarvestDays": "21",
          "hasHarvest": 0,
          "progressRate": 0.6557377,
          "productUrl": "95800dc2c0a941f18af50325dc571bfc",
          "traceBatchInfoId": "9c7c6cc541634c4fae8ab5e2d9348a7d",
          "productName": "试验西瓜",
          "startDate": "2019-09-27",
          "massId": "9679093957eb4348b9f75543a289382a",
          "productId": "1d93f82fb76d4418bd2a5da1de452506",
          "areaUnitName": "亩",
          "partitionName": "单体棚",
          "partitionId": "23c5a2eec0104bf082047c61b6920c06",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-10-17 16:58:04",
          "id": 340,
          "massAreaVal": 0.38
        }],
        "D7": [{
          "massIfName": "D7",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "0.38",
          "traceBatchName": "试验圣女果_D7_20191017",
          "toHarvestDays": "120",
          "hasHarvest": 0,
          "progressRate": 0.31034482,
          "productUrl": "46676e2a1ef84a128d3c4d1e731ca8f5",
          "traceBatchInfoId": "4c4e2abd4f204d2ab2d06b6f18698eb7",
          "productName": "试验圣女果",
          "startDate": "2019-09-13",
          "massId": "fbde48394efe44158c5264fee351b931",
          "productId": "91244f69d44341739cf6c175cbfb00f8",
          "areaUnitName": "亩",
          "partitionName": "单体棚",
          "partitionId": "23c5a2eec0104bf082047c61b6920c06",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-10-17 16:44:50",
          "id": 335,
          "massAreaVal": 0.38
        }],
        "D8": [{
          "massIfName": "D8",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "0.38",
          "traceBatchName": "试验圣女果_D8_20191017",
          "toHarvestDays": "120",
          "hasHarvest": 0,
          "progressRate": 0.31034482,
          "productUrl": "46676e2a1ef84a128d3c4d1e731ca8f5",
          "traceBatchInfoId": "95ebe37edb454467a2e693b4c3d85092",
          "productName": "试验圣女果",
          "startDate": "2019-09-13",
          "massId": "c2a1a4345da544be87b5f8618dd39b16",
          "productId": "91244f69d44341739cf6c175cbfb00f8",
          "areaUnitName": "亩",
          "partitionName": "单体棚",
          "partitionId": "23c5a2eec0104bf082047c61b6920c06",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-10-17 16:45:51",
          "id": 336,
          "massAreaVal": 0.38
        }],
        "D9": [{
          "massIfName": "D9",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "0.38",
          "traceBatchName": "试验圣女果_D9_20191017",
          "toHarvestDays": "120",
          "hasHarvest": 0,
          "progressRate": 0.31034482,
          "productUrl": "46676e2a1ef84a128d3c4d1e731ca8f5",
          "traceBatchInfoId": "cbeccc8fc6314d19bf391c4440fb1ee9",
          "productName": "试验圣女果",
          "startDate": "2019-09-13",
          "massId": "85f25eee14804242901771c88003da36",
          "productId": "91244f69d44341739cf6c175cbfb00f8",
          "areaUnitName": "亩",
          "partitionName": "单体棚",
          "partitionId": "23c5a2eec0104bf082047c61b6920c06",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-10-17 16:46:40",
          "id": 337,
          "massAreaVal": 0.38
        }],
        "展-2A": [{
          "massIfName": "展-2A",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "林鸿图",
          "massArea": "1532.0",
          "hasHarvest": 0,
          "massId": "37615fa53d6b49ae943fcdb5c94f5edf",
          "areaUnitName": "平方米",
          "partitionName": "展示区",
          "massAreaVal": 1532
        }],
        "展-2B": [{
          "massIfName": "展-2B",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "林鸿图",
          "massArea": "1532.0",
          "hasHarvest": 0,
          "massId": "c90327e44c0e451fafa3a2df9dff631f",
          "areaUnitName": "平方米",
          "partitionName": "展示区",
          "massAreaVal": 1532
        }],
        "展-2C": [{
          "massIfName": "展-2C",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "林鸿图",
          "massArea": "1532.0",
          "traceBatchName": "曼西娜番茄_展-2C_20191029",
          "toHarvestDays": "82",
          "hasHarvest": 0,
          "progressRate": 0.344,
          "productUrl": "da99ceacf66b4f90bbaa1ab93fd49cec",
          "traceBatchInfoId": "6e42014a159b4fc0943d4f37fdc272be",
          "productName": "曼西娜番茄",
          "startDate": "2019-09-24",
          "massId": "097916fc0ba14ae6b1f08b05b653ce6c",
          "productId": "6e75b25cf8654cbb8ea2a77eb7e0c3b4",
          "areaUnitName": "平方米",
          "partitionName": "展示区",
          "partitionId": "a436f19ac3bc46cdb566b1c045f1c2c5",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-10-29 17:01:17",
          "id": 380,
          "massAreaVal": 1532
        }],
        "展-2D": [{
          "massIfName": "展-2D",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "林鸿图",
          "massArea": "1532.0",
          "traceBatchName": "永优黄灯笼辣椒_展-2D_20190905",
          "hasHarvest": 0,
          "traceBatchInfoId": "72f2636c81c0473ba925d921c80b78a4",
          "productName": "永优黄灯笼辣椒",
          "startDate": "2019-09-05",
          "massId": "8fa29c0468de4d1e818b0ed2de06513f",
          "productId": "ed65a6819e7747e5be8db447620a3385",
          "areaUnitName": "平方米",
          "partitionName": "展示区",
          "partitionId": "a436f19ac3bc46cdb566b1c045f1c2c5",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-09-05 21:02:59",
          "id": 237,
          "massAreaVal": 1532
        }],
        "展-叶菜区": [{
          "massIfName": "展-叶菜区",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "林鸿图",
          "massArea": "3.46",
          "traceBatchName": "潮州快大夏皇白_展-叶菜区_20190923",
          "hasHarvest": 0,
          "productUrl": "16182b0db47c44698a436be9e42231cc",
          "traceBatchInfoId": "ba48b86eadd441ceab28ef40f6e7296a",
          "productName": "潮州快大夏皇白",
          "startDate": "2019-09-02",
          "harvestQuantity": 3921,
          "harvestDamagedQuantity": 0,
          "massId": "d7aac8fc55cf4d39871d844eb215d048",
          "productId": "648a21743c0a468499e37f807ef24e7f",
          "harvestDate": "2019-09-24",
          "areaUnitName": "亩",
          "partitionName": "展示区",
          "partitionId": "a436f19ac3bc46cdb566b1c045f1c2c5",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-09-23 21:57:40",
          "harvestCreateTime": 1569290697617,
          "id": 298,
          "massAreaVal": 3.46
        }],
        "展示大棚": [{
          "massIfName": "展示大棚",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "林鸿图",
          "massArea": "9500.0",
          "hasHarvest": 0,
          "massId": "718722a0322a4b28b70de55a82a9a019",
          "areaUnitName": "平方米",
          "partitionName": "展示区",
          "massAreaVal": 9500
        }]
      }
      for (var key in resultData) {
        for (var i = 0; i < list.length; i++) {
          if (key === list[i].name) {
            list[i].setList(resultData[key])
            this.datalist.push(resultData[key])
          }
        }
        for (var j = 0; j < rightlist.length; j++) {
          if (key === rightlist[j].name) {
            rightlist[j].setList(resultData[key])
            this.datalist.push(resultData[key])
          }
        }
      }
      this.massifList = list
      this.massifListR = rightlist
      console.log(this.datalist)
      this.time()
    } else {
      // this.$message.showError(err);
      var data = {
        "10号棚": [{
          "massIfName": "10号棚",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "4488.0",
          "hasHarvest": 0,
          "massId": "5da6b24187944a778a1e1867c8757923",
          "areaUnitName": "平方米",
          "partitionName": "老园区",
          "massAreaVal": 4488
        }],
        "12号棚": [{
          "massIfName": "12号棚",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "1824.0",
          "hasHarvest": 0,
          "massId": "7f458d2a56d6428ea205bf60806e6c14",
          "areaUnitName": "平方米",
          "partitionName": "老园区",
          "massAreaVal": 1824
        }],
        "13号棚": [{
          "massIfName": "13号棚",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "1152.0",
          "hasHarvest": 0,
          "massId": "6161573284224bab92fd36ae41dc6e03",
          "areaUnitName": "平方米",
          "partitionName": "老园区",
          "massAreaVal": 1152
        }],
        "14号棚": [{
          "massIfName": "14号棚",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "1152.0",
          "hasHarvest": 0,
          "massId": "5adcad3d40b143ada96b2624a88b75dd",
          "areaUnitName": "平方米",
          "partitionName": "老园区",
          "massAreaVal": 1152
        }],
        "15号棚": [{
          "massIfName": "15号棚",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "960.0",
          "hasHarvest": 0,
          "massId": "405421605f8242ffbeca94ed87f76bcb",
          "areaUnitName": "平方米",
          "partitionName": "老园区",
          "massAreaVal": 960
        }],
        "16-1": [{
          "massIfName": "16-1",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "黄德振",
          "massArea": "5960.0",
          "traceBatchName": "美月西瓜_16-1_20190822",
          "toHarvestDays": "-2",
          "hasHarvest": 0,
          "progressRate": 1.027027,
          "productUrl": "7efa1db47ccd499a83413377beb70431",
          "traceBatchInfoId": "4998b975ed0b47428978bb0d93bd9c74",
          "productName": "美月西瓜",
          "startDate": "2019-08-22",
          "harvestQuantity": 64360,
          "harvestDamagedQuantity": 734,
          "massId": "628654838b564fc381d56e06f8072862",
          "productId": "0b2d4ee67c984d838cea64bafb64179d",
          "harvestDate": "2019-11-04",
          "areaUnitName": "平方米",
          "partitionName": "中荷温室",
          "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-08-22 19:48:30",
          "harvestCreateTime": 1572861140941,
          "id": 186,
          "massAreaVal": 5960
        }],
        "16-10": [{
          "massIfName": "16-10",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "黄德振",
          "massArea": "5636.0",
          "traceBatchName": "美月西瓜_16-10_20191015",
          "toHarvestDays": "51",
          "hasHarvest": 0,
          "progressRate": 0.32,
          "productUrl": "7efa1db47ccd499a83413377beb70431",
          "traceBatchInfoId": "949082d39cc7401e8cab70ca79004657",
          "productName": "美月西瓜",
          "startDate": "2019-10-13",
          "massId": "06b9818a3a344d1cb98f5ece106d7139",
          "productId": "0b2d4ee67c984d838cea64bafb64179d",
          "areaUnitName": "平方米",
          "partitionName": "中荷温室",
          "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-10-15 16:13:11",
          "id": 332,
          "massAreaVal": 5636
        }, {
          "massIfName": "16-10",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "黄德振",
          "massArea": "5636.0",
          "traceBatchName": "美月西瓜_16-10_20190902",
          "toHarvestDays": "0",
          "hasHarvest": 1,
          "progressRate": 1,
          "productUrl": "7efa1db47ccd499a83413377beb70431",
          "traceBatchInfoId": "eb48887da2f8465d824659afb42fb3dc",
          "productName": "美月西瓜",
          "startDate": "2019-08-06",
          "harvestQuantity": 14883,
          "harvestDamagedQuantity": 140,
          "massId": "06b9818a3a344d1cb98f5ece106d7139",
          "productId": "0b2d4ee67c984d838cea64bafb64179d",
          "harvestDate": "2019-10-12",
          "areaUnitName": "平方米",
          "partitionName": "中荷温室",
          "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 2,
          "createTime": "2019-09-02 23:44:45",
          "harvestCreateTime": 1571129662779,
          "id": 226,
          "massAreaVal": 5636
        }],
        "16-11": [{
          "massIfName": "16-11",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "黄德振",
          "massArea": "7152.0",
          "traceBatchName": "美月西瓜_16-11_20190904",
          "toHarvestDays": "11",
          "hasHarvest": 0,
          "progressRate": 0.8513514,
          "productUrl": "7efa1db47ccd499a83413377beb70431",
          "traceBatchInfoId": "a339cbf54b2e430aa04297689118a07a",
          "productName": "美月西瓜",
          "startDate": "2019-09-04",
          "massId": "caf0c5e5f500424aab26b66a4b01d2fb",
          "productId": "0b2d4ee67c984d838cea64bafb64179d",
          "areaUnitName": "平方米",
          "partitionName": "中荷温室",
          "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-09-04 21:52:36",
          "id": 234,
          "massAreaVal": 7152
        }],
        "16-12": [{
          "massIfName": "16-12",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "黄德振",
          "massArea": "6768.0",
          "traceBatchName": "美月西瓜_16-12_20190924",
          "toHarvestDays": "24",
          "hasHarvest": 0,
          "progressRate": 0.6712329,
          "productUrl": "7efa1db47ccd499a83413377beb70431",
          "traceBatchInfoId": "7f87f62dab0540d7b275cb405b9c5788",
          "productName": "美月西瓜",
          "startDate": "2019-09-18",
          "massId": "b84e9c0106d64227ab51a2e34e98d1cf",
          "productId": "0b2d4ee67c984d838cea64bafb64179d",
          "areaUnitName": "平方米",
          "partitionName": "中荷温室",
          "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-09-24 15:00:59",
          "id": 300,
          "massAreaVal": 6768
        }],
        "16-2": [{
          "massIfName": "16-2",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "黄德振",
          "massArea": "5640.0",
          "traceBatchName": "美月西瓜_16-2_20190818",
          "toHarvestDays": "-8",
          "hasHarvest": 0,
          "progressRate": 1.1111112,
          "productUrl": "7efa1db47ccd499a83413377beb70431",
          "traceBatchInfoId": "1d6b950c60f14f87a85587c76aec6056",
          "productName": "美月西瓜",
          "startDate": "2019-08-18",
          "massId": "30596634280f4c88a320ef3dd911c41b",
          "productId": "0b2d4ee67c984d838cea64bafb64179d",
          "areaUnitName": "平方米",
          "partitionName": "中荷温室",
          "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-08-18 21:58:05",
          "id": 183,
          "massAreaVal": 5640
        }],
        "16-3": [{
          "massIfName": "16-3",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "黄德振",
          "massArea": "5960.0",
          "traceBatchName": "美月西瓜_16-3_20190826",
          "toHarvestDays": "-66",
          "hasHarvest": 0,
          "progressRate": 12,
          "productUrl": "7efa1db47ccd499a83413377beb70431",
          "traceBatchInfoId": "f48f9b325b734ddfa9b187aedb7d21e9",
          "productName": "美月西瓜",
          "startDate": "2019-08-26",
          "massId": "b2bc1a0be0e84abe9a90f52ed90e5e1b",
          "productId": "0b2d4ee67c984d838cea64bafb64179d",
          "areaUnitName": "平方米",
          "partitionName": "中荷温室",
          "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-08-26 22:14:39",
          "id": 189,
          "massAreaVal": 5960
        }],
        "16-4": [{
          "massIfName": "16-4",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "黄德振",
          "massArea": "5640.0",
          "traceBatchName": "美月西瓜_16-4_20190831",
          "toHarvestDays": "6",
          "hasHarvest": 0,
          "progressRate": 0.91780823,
          "productUrl": "7efa1db47ccd499a83413377beb70431",
          "traceBatchInfoId": "69e05d8245014c2d9d0a84ec694bd5e6",
          "productName": "美月西瓜",
          "startDate": "2019-08-31",
          "massId": "8095b224d21c469681b3adebbc2639b2",
          "productId": "0b2d4ee67c984d838cea64bafb64179d",
          "areaUnitName": "平方米",
          "partitionName": "中荷温室",
          "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-08-31 19:59:52",
          "id": 217,
          "massAreaVal": 5640
        }],
        "16-5": [{
          "massIfName": "16-5",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "黄德振",
          "massArea": "5960.0",
          "traceBatchName": "美月西瓜_16-5_20190923",
          "toHarvestDays": "3",
          "hasHarvest": 0,
          "progressRate": 0.95454544,
          "productUrl": "7efa1db47ccd499a83413377beb70431",
          "traceBatchInfoId": "83da26865fa441799bad62ac5958a975",
          "productName": "美月西瓜",
          "startDate": "2019-09-04",
          "massId": "f53c67ab0b484dcea2c0d6a397828200",
          "productId": "0b2d4ee67c984d838cea64bafb64179d",
          "areaUnitName": "平方米",
          "partitionName": "中荷温室",
          "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-09-23 21:15:05",
          "id": 296,
          "massAreaVal": 5960
        }],
        "16-6": [{
          "massIfName": "16-6",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "黄德振",
          "massArea": "5462.0",
          "hasHarvest": 0,
          "massId": "66afdfa9d0c94ebe942d02682354c218",
          "areaUnitName": "平方米",
          "partitionName": "中荷温室",
          "massAreaVal": 5462
        }],
        "16-7": [{
          "massIfName": "16-7",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "黄德振",
          "massArea": "6536.0",
          "traceBatchName": "美月西瓜_16-7_20191012",
          "toHarvestDays": "40",
          "hasHarvest": 0,
          "progressRate": 0.4520548,
          "productUrl": "7efa1db47ccd499a83413377beb70431",
          "traceBatchInfoId": "1984f8d59c2f4359979dff923e49071c",
          "productName": "美月西瓜",
          "startDate": "2019-10-04",
          "massId": "ffb9b8a7890e449bbfbec5326a4d2a26",
          "productId": "0b2d4ee67c984d838cea64bafb64179d",
          "areaUnitName": "平方米",
          "partitionName": "中荷温室",
          "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-10-12 12:08:40",
          "id": 319,
          "massAreaVal": 6536
        }],
        "16-8": [{
          "massIfName": "16-8",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "黄德振",
          "massArea": "6203.0",
          "hasHarvest": 0,
          "massId": "7932fe634ff84135bf616c3665171bd0",
          "areaUnitName": "平方米",
          "partitionName": "中荷温室",
          "massAreaVal": 6203
        }],
        "16-9": [{
          "massIfName": "16-9",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "黄德振",
          "massArea": "5736.0",
          "traceBatchName": "美月西瓜_16-9_20190902",
          "toHarvestDays": "0",
          "hasHarvest": 1,
          "progressRate": 1,
          "productUrl": "7efa1db47ccd499a83413377beb70431",
          "traceBatchInfoId": "580db7cc3761457183af7b0be3fc0911",
          "productName": "美月西瓜",
          "startDate": "2019-08-13",
          "harvestQuantity": 13147,
          "harvestDamagedQuantity": 15,
          "massId": "56a5fbb4f6b641daa0d56bae99261067",
          "productId": "0b2d4ee67c984d838cea64bafb64179d",
          "harvestDate": "2019-10-21",
          "areaUnitName": "平方米",
          "partitionName": "中荷温室",
          "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 2,
          "createTime": "2019-09-02 23:45:56",
          "harvestCreateTime": 1571828586702,
          "id": 227,
          "massAreaVal": 5736
        }],
        "1号棚": [{
          "massIfName": "1号棚",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "3840.0",
          "hasHarvest": 0,
          "massId": "82a7d7497b2c480a8588ae633ed1fed5",
          "areaUnitName": "平方米",
          "partitionName": "老园区",
          "massAreaVal": 3840
        }],
        "2号棚": [{
          "massIfName": "2号棚",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "3840.0",
          "hasHarvest": 0,
          "massId": "b648e2e829144d4d88db432519d3f0ca",
          "areaUnitName": "平方米",
          "partitionName": "老园区",
          "massAreaVal": 3840
        }],
        "3号棚": [{
          "massIfName": "3号棚",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "3840.0",
          "hasHarvest": 0,
          "massId": "60e1a5484b4e4185a6f84b413ec0123e",
          "areaUnitName": "平方米",
          "partitionName": "老园区",
          "massAreaVal": 3840
        }],
        "4号棚": [{
          "massIfName": "4号棚",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "960.0",
          "hasHarvest": 0,
          "massId": "e0121eb1b20249f5a4f1921689f0f4b8",
          "areaUnitName": "平方米",
          "partitionName": "老园区",
          "massAreaVal": 960
        }],
        "581-1": [{
          "massIfName": "581-1",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6080.0",
          "traceBatchName": "美月西瓜_581-1_20190908",
          "toHarvestDays": "0",
          "hasHarvest": 1,
          "progressRate": 1,
          "productUrl": "7efa1db47ccd499a83413377beb70431",
          "traceBatchInfoId": "4803bec142df4c7c8b81344f14385969",
          "productName": "美月西瓜",
          "harvestQuantity": 17198,
          "harvestDamagedQuantity": 250,
          "massId": "a71183836d634425be34001674d28011",
          "productId": "0b2d4ee67c984d838cea64bafb64179d",
          "harvestDate": "2019-10-22",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 2,
          "createTime": "2019-09-08 19:08:26",
          "harvestCreateTime": 1571736980512,
          "id": 245,
          "massAreaVal": 6080
        }],
        "581-10": [{
          "massIfName": "581-10",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6080.0",
          "hasHarvest": 0,
          "massId": "70fa77f342484e448b043fea4f15807b",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6080
        }],
        "581-11": [{
          "massIfName": "581-11",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "da7ea37570f6457da4b7ea57b3ba7a0e",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-12": [{
          "massIfName": "581-12",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "649cf669ea50497abf0e2d654a5a0394",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-13": [{
          "massIfName": "581-13",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "192737df21064002a87b1a900330a822",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-14": [{
          "massIfName": "581-14",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "8901900a1de14e619baa1657e10c12b6",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-15": [{
          "massIfName": "581-15",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "1632a87c41264b449c2c2c50308780bd",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-16": [{
          "massIfName": "581-16",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "43600f01a840498fa87358e1db1ad723",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-17": [{
          "massIfName": "581-17",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "0767994c6c944a568fea24452a78503a",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-18": [{
          "massIfName": "581-18",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "6499f5114e32433f883f70b09be18911",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-19": [{
          "massIfName": "581-19",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "13d7b6c1471c49b0820234d8aadba8c8",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-2": [{
          "massIfName": "581-2",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "traceBatchName": "美月西瓜_581-2_20190930",
          "hasHarvest": 0,
          "productUrl": "7efa1db47ccd499a83413377beb70431",
          "traceBatchInfoId": "279c211d544a42d9ba77ace6ddbfe1b0",
          "productName": "美月西瓜",
          "startDate": "2019-09-27",
          "massId": "1f959a5d82604b0da975f6002472ae24",
          "productId": "0b2d4ee67c984d838cea64bafb64179d",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-09-30 20:26:21",
          "id": 315,
          "massAreaVal": 6688
        }],
        "581-20": [{
          "massIfName": "581-20",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "7a570059e21844999df90b76ed0e2cbe",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-21": [{
          "massIfName": "581-21",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "ec30417d2aae4d62ba13b1d9ed8e641d",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-22": [{
          "massIfName": "581-22",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "5ffdd43db13a4fa3aa042f8f7c043430",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-23": [{
          "massIfName": "581-23",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "cfdd0c990e1a478fbcbaf8ae60dfe231",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-24": [{
          "massIfName": "581-24",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "c85f7ce299984c0ab29d4150b78a0645",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-25": [{
          "massIfName": "581-25",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "8cb7080522154bb5a13c2e4f957ddec7",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-26": [{
          "massIfName": "581-26",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "0a9bb5a9581946ee965c49cbb29263c5",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-27": [{
          "massIfName": "581-27",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "11fe60cbd69d4ed2994386199ca425ec",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-28": [{
          "massIfName": "581-28",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "traceBatchName": "美月西瓜_581-28_20190923",
          "hasHarvest": 0,
          "productUrl": "7efa1db47ccd499a83413377beb70431",
          "traceBatchInfoId": "4ae35cea0e784b4f92cf5e3d6aaf88ea",
          "productName": "美月西瓜",
          "massId": "4d4f35f175dd4942ac698497cf409b00",
          "productId": "0b2d4ee67c984d838cea64bafb64179d",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-09-23 21:49:26",
          "id": 297,
          "massAreaVal": 6688
        }],
        "581-29": [{
          "massIfName": "581-29",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "林鸿图",
          "massArea": "2816.0",
          "hasHarvest": 0,
          "massId": "809cdd4e59214c97b524abdb2b6aac64",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 2816
        }],
        "581-3": [{
          "massIfName": "581-3",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "29ec59c9be394d298e464d919a5268e3",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-4": [{
          "massIfName": "581-4",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "traceBatchName": "千禧圣女果_581-4_20191012",
          "hasHarvest": 0,
          "productUrl": "aafefdaa8f8a488c8f8a09a92252bdbd",
          "traceBatchInfoId": "70fb136d8a1a42119a62263c7a60627d",
          "productName": "千禧圣女果",
          "startDate": "2019-09-23",
          "massId": "70804d660171419e94de93509a066c1f",
          "productId": "5648db043ce64be28d3f8c30f8876164",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-10-12 12:25:47",
          "id": 322,
          "massAreaVal": 6688
        }],
        "581-5": [{
          "massIfName": "581-5",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6080.0",
          "traceBatchName": "千禧圣女果_581-5_20191012",
          "hasHarvest": 0,
          "productUrl": "aafefdaa8f8a488c8f8a09a92252bdbd",
          "traceBatchInfoId": "cbab910912b74999aa4eff71fedee332",
          "productName": "千禧圣女果",
          "startDate": "2019-09-24",
          "massId": "1eef15f5af1547d4b335ecd3920ccde0",
          "productId": "5648db043ce64be28d3f8c30f8876164",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-10-12 12:27:03",
          "id": 323,
          "massAreaVal": 6080
        }],
        "581-6": [{
          "massIfName": "581-6",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "traceBatchName": "美月西瓜_581-6_20190930",
          "toHarvestDays": "14",
          "hasHarvest": 0,
          "progressRate": 0.7307692,
          "productUrl": "7efa1db47ccd499a83413377beb70431",
          "traceBatchInfoId": "7163ead1d62e425f964da3633ea6b121",
          "productName": "美月西瓜",
          "startDate": "2019-09-29",
          "massId": "3d2d32ca91004bf98d3745d3e33bf728",
          "productId": "0b2d4ee67c984d838cea64bafb64179d",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-09-30 20:27:21",
          "id": 316,
          "massAreaVal": 6688
        }],
        "581-7": [{
          "massIfName": "581-7",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "traceBatchName": "美月西瓜_581-7_20190825",
          "toHarvestDays": "-21",
          "hasHarvest": 0,
          "progressRate": 1.4038461,
          "productUrl": "7efa1db47ccd499a83413377beb70431",
          "traceBatchInfoId": "cf0b69f5402e4d5992b08f156e7b7490",
          "productName": "美月西瓜",
          "startDate": "2019-08-25",
          "massId": "80ee7363d44e4d4a92f2d629521ad4dd",
          "productId": "0b2d4ee67c984d838cea64bafb64179d",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-08-25 22:34:36",
          "id": 188,
          "massAreaVal": 6688
        }],
        "581-8": [{
          "massIfName": "581-8",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "589a973f7b114735a322b6604f86caf4",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "581-9": [{
          "massIfName": "581-9",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "苏记春",
          "massArea": "6688.0",
          "hasHarvest": 0,
          "massId": "21ad8dbaddd34a479b899d4f0714ef44",
          "areaUnitName": "平方米",
          "partitionName": "581区域",
          "massAreaVal": 6688
        }],
        "5号棚": [{
          "massIfName": "5号棚",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "960.0",
          "hasHarvest": 0,
          "massId": "6cd116f8f77a455c8017db42df934b10",
          "areaUnitName": "平方米",
          "partitionName": "老园区",
          "massAreaVal": 960
        }],
        "6号棚": [{
          "massIfName": "6号棚",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "960.0",
          "hasHarvest": 0,
          "massId": "9c458864d4404387bf9a77664bb5059b",
          "areaUnitName": "平方米",
          "partitionName": "老园区",
          "massAreaVal": 960
        }],
        "7号棚": [{
          "massIfName": "7号棚",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "3456.0",
          "hasHarvest": 0,
          "massId": "65df5b086e1b4e7b84909f49d3068c9b",
          "areaUnitName": "平方米",
          "partitionName": "老园区",
          "massAreaVal": 3456
        }],
        "8号棚": [{
          "massIfName": "8号棚",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "3456.0",
          "hasHarvest": 0,
          "massId": "dc03b56080c3499982395b2d52b23a7c",
          "areaUnitName": "平方米",
          "partitionName": "老园区",
          "massAreaVal": 3456
        }],
        "9号棚": [{
          "massIfName": "9号棚",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "3456.0",
          "hasHarvest": 0,
          "massId": "34534f5a1d344e4aadefa38cc1090154",
          "areaUnitName": "平方米",
          "partitionName": "老园区",
          "massAreaVal": 3456
        }],
        "D0": [{
          "massIfName": "D0",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "0.38",
          "traceBatchName": "辣木_D0_20191017",
          "toHarvestDays": "827",
          "hasHarvest": 0,
          "progressRate": 0.045034643,
          "productUrl": "784bd0037268432a94587ce223230b39",
          "traceBatchInfoId": "332dd859a6654339959e881eee499dad",
          "productName": "辣木",
          "startDate": "2019-09-28",
          "massId": "b20cf9abd0fc458c8465783005bb9ecd",
          "productId": "f0465ccbd45d46ecb8f1c39bf6e6369e",
          "areaUnitName": "亩",
          "partitionName": "单体棚",
          "partitionId": "23c5a2eec0104bf082047c61b6920c06",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-10-17 16:37:25",
          "id": 333,
          "massAreaVal": 0.38
        }],
        "D1": [{
          "massIfName": "D1",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "0.38",
          "traceBatchName": "美月西瓜_D1_20191018",
          "toHarvestDays": "22",
          "hasHarvest": 0,
          "progressRate": 0.6393443,
          "productUrl": "7efa1db47ccd499a83413377beb70431",
          "traceBatchInfoId": "5595473d29d94e4fb47c8a3153bd3160",
          "productName": "美月西瓜",
          "startDate": "2019-09-28",
          "massId": "6c75b19a5f63487bbadf93dc843a1e1f",
          "productId": "0b2d4ee67c984d838cea64bafb64179d",
          "areaUnitName": "亩",
          "partitionName": "单体棚",
          "partitionId": "23c5a2eec0104bf082047c61b6920c06",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-10-18 12:10:53",
          "id": 353,
          "massAreaVal": 0.38
        }],
        "D10": [{
          "massIfName": "D10",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "0.38",
          "traceBatchName": "试验圣女果_D10_20191017",
          "toHarvestDays": "120",
          "hasHarvest": 0,
          "progressRate": 0.31034482,
          "productUrl": "46676e2a1ef84a128d3c4d1e731ca8f5",
          "traceBatchInfoId": "afd7d2d3cd6d452ba674a5b35dada11c",
          "productName": "试验圣女果",
          "startDate": "2019-09-13",
          "massId": "92dc3b5740db43c7874ea0b8a1d832af",
          "productId": "91244f69d44341739cf6c175cbfb00f8",
          "areaUnitName": "亩",
          "partitionName": "单体棚",
          "partitionId": "23c5a2eec0104bf082047c61b6920c06",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-10-17 16:47:21",
          "id": 338,
          "massAreaVal": 0.38
        }],
        "D2": [{
          "massIfName": "D2",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "0.38",
          "hasHarvest": 0,
          "massId": "14c6ba17c4b54cdb96e8cd70071c0a92",
          "areaUnitName": "亩",
          "partitionName": "单体棚",
          "massAreaVal": 0.38
        }],
        "D3": [{
          "massIfName": "D3",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "0.38",
          "hasHarvest": 0,
          "massId": "1cfef5a003534d8fb9f0e1dd1a9ce0cb",
          "areaUnitName": "亩",
          "partitionName": "单体棚",
          "massAreaVal": 0.38
        }],
        "D4": [{
          "massIfName": "D4",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "0.38",
          "hasHarvest": 0,
          "massId": "b3a406d6d5f64d27a91c9ac737877a4d",
          "areaUnitName": "亩",
          "partitionName": "单体棚",
          "massAreaVal": 0.38
        }],
        "D5": [{
          "massIfName": "D5",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "0.38",
          "traceBatchName": "试验西瓜_D5_20191017",
          "toHarvestDays": "21",
          "hasHarvest": 0,
          "progressRate": 0.6557377,
          "productUrl": "95800dc2c0a941f18af50325dc571bfc",
          "traceBatchInfoId": "2aaaf3d574d0420f8ef93ad9c7809c82",
          "productName": "试验西瓜",
          "startDate": "2019-09-27",
          "massId": "5d12c9b3ec154568ba17aca75394a58f",
          "productId": "1d93f82fb76d4418bd2a5da1de452506",
          "areaUnitName": "亩",
          "partitionName": "单体棚",
          "partitionId": "23c5a2eec0104bf082047c61b6920c06",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-10-17 16:57:20",
          "id": 339,
          "massAreaVal": 0.38
        }],
        "D6": [{
          "massIfName": "D6",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "0.38",
          "traceBatchName": "试验西瓜_D6_20191017",
          "toHarvestDays": "21",
          "hasHarvest": 0,
          "progressRate": 0.6557377,
          "productUrl": "95800dc2c0a941f18af50325dc571bfc",
          "traceBatchInfoId": "9c7c6cc541634c4fae8ab5e2d9348a7d",
          "productName": "试验西瓜",
          "startDate": "2019-09-27",
          "massId": "9679093957eb4348b9f75543a289382a",
          "productId": "1d93f82fb76d4418bd2a5da1de452506",
          "areaUnitName": "亩",
          "partitionName": "单体棚",
          "partitionId": "23c5a2eec0104bf082047c61b6920c06",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-10-17 16:58:04",
          "id": 340,
          "massAreaVal": 0.38
        }],
        "D7": [{
          "massIfName": "D7",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "0.38",
          "traceBatchName": "试验圣女果_D7_20191017",
          "toHarvestDays": "120",
          "hasHarvest": 0,
          "progressRate": 0.31034482,
          "productUrl": "46676e2a1ef84a128d3c4d1e731ca8f5",
          "traceBatchInfoId": "4c4e2abd4f204d2ab2d06b6f18698eb7",
          "productName": "试验圣女果",
          "startDate": "2019-09-13",
          "massId": "fbde48394efe44158c5264fee351b931",
          "productId": "91244f69d44341739cf6c175cbfb00f8",
          "areaUnitName": "亩",
          "partitionName": "单体棚",
          "partitionId": "23c5a2eec0104bf082047c61b6920c06",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-10-17 16:44:50",
          "id": 335,
          "massAreaVal": 0.38
        }],
        "D8": [{
          "massIfName": "D8",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "0.38",
          "traceBatchName": "试验圣女果_D8_20191017",
          "toHarvestDays": "120",
          "hasHarvest": 0,
          "progressRate": 0.31034482,
          "productUrl": "46676e2a1ef84a128d3c4d1e731ca8f5",
          "traceBatchInfoId": "95ebe37edb454467a2e693b4c3d85092",
          "productName": "试验圣女果",
          "startDate": "2019-09-13",
          "massId": "c2a1a4345da544be87b5f8618dd39b16",
          "productId": "91244f69d44341739cf6c175cbfb00f8",
          "areaUnitName": "亩",
          "partitionName": "单体棚",
          "partitionId": "23c5a2eec0104bf082047c61b6920c06",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-10-17 16:45:51",
          "id": 336,
          "massAreaVal": 0.38
        }],
        "D9": [{
          "massIfName": "D9",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "莫达春",
          "massArea": "0.38",
          "traceBatchName": "试验圣女果_D9_20191017",
          "toHarvestDays": "120",
          "hasHarvest": 0,
          "progressRate": 0.31034482,
          "productUrl": "46676e2a1ef84a128d3c4d1e731ca8f5",
          "traceBatchInfoId": "cbeccc8fc6314d19bf391c4440fb1ee9",
          "productName": "试验圣女果",
          "startDate": "2019-09-13",
          "massId": "85f25eee14804242901771c88003da36",
          "productId": "91244f69d44341739cf6c175cbfb00f8",
          "areaUnitName": "亩",
          "partitionName": "单体棚",
          "partitionId": "23c5a2eec0104bf082047c61b6920c06",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-10-17 16:46:40",
          "id": 337,
          "massAreaVal": 0.38
        }],
        "展-2A": [{
          "massIfName": "展-2A",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "林鸿图",
          "massArea": "1532.0",
          "hasHarvest": 0,
          "massId": "37615fa53d6b49ae943fcdb5c94f5edf",
          "areaUnitName": "平方米",
          "partitionName": "展示区",
          "massAreaVal": 1532
        }],
        "展-2B": [{
          "massIfName": "展-2B",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "林鸿图",
          "massArea": "1532.0",
          "hasHarvest": 0,
          "massId": "c90327e44c0e451fafa3a2df9dff631f",
          "areaUnitName": "平方米",
          "partitionName": "展示区",
          "massAreaVal": 1532
        }],
        "展-2C": [{
          "massIfName": "展-2C",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "林鸿图",
          "massArea": "1532.0",
          "traceBatchName": "曼西娜番茄_展-2C_20191029",
          "toHarvestDays": "82",
          "hasHarvest": 0,
          "progressRate": 0.344,
          "productUrl": "da99ceacf66b4f90bbaa1ab93fd49cec",
          "traceBatchInfoId": "6e42014a159b4fc0943d4f37fdc272be",
          "productName": "曼西娜番茄",
          "startDate": "2019-09-24",
          "massId": "097916fc0ba14ae6b1f08b05b653ce6c",
          "productId": "6e75b25cf8654cbb8ea2a77eb7e0c3b4",
          "areaUnitName": "平方米",
          "partitionName": "展示区",
          "partitionId": "a436f19ac3bc46cdb566b1c045f1c2c5",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-10-29 17:01:17",
          "id": 380,
          "massAreaVal": 1532
        }],
        "展-2D": [{
          "massIfName": "展-2D",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "林鸿图",
          "massArea": "1532.0",
          "traceBatchName": "永优黄灯笼辣椒_展-2D_20190905",
          "hasHarvest": 0,
          "traceBatchInfoId": "72f2636c81c0473ba925d921c80b78a4",
          "productName": "永优黄灯笼辣椒",
          "startDate": "2019-09-05",
          "massId": "8fa29c0468de4d1e818b0ed2de06513f",
          "productId": "ed65a6819e7747e5be8db447620a3385",
          "areaUnitName": "平方米",
          "partitionName": "展示区",
          "partitionId": "a436f19ac3bc46cdb566b1c045f1c2c5",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-09-05 21:02:59",
          "id": 237,
          "massAreaVal": 1532
        }],
        "展-叶菜区": [{
          "massIfName": "展-叶菜区",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "林鸿图",
          "massArea": "3.46",
          "traceBatchName": "潮州快大夏皇白_展-叶菜区_20190923",
          "hasHarvest": 0,
          "productUrl": "16182b0db47c44698a436be9e42231cc",
          "traceBatchInfoId": "ba48b86eadd441ceab28ef40f6e7296a",
          "productName": "潮州快大夏皇白",
          "startDate": "2019-09-02",
          "harvestQuantity": 3921,
          "harvestDamagedQuantity": 0,
          "massId": "d7aac8fc55cf4d39871d844eb215d048",
          "productId": "648a21743c0a468499e37f807ef24e7f",
          "harvestDate": "2019-09-24",
          "areaUnitName": "亩",
          "partitionName": "展示区",
          "partitionId": "a436f19ac3bc46cdb566b1c045f1c2c5",
          "organizationId": "864191543bbb45558801605515197f98",
          "endFlag": 3,
          "createTime": "2019-09-23 21:57:40",
          "harvestCreateTime": 1569290697617,
          "id": 298,
          "massAreaVal": 3.46
        }],
        "展示大棚": [{
          "massIfName": "展示大棚",
          "baseName": "海南润达现代农业集团股份有限公司",
          "principalName": "林鸿图",
          "massArea": "9500.0",
          "hasHarvest": 0,
          "massId": "718722a0322a4b28b70de55a82a9a019",
          "areaUnitName": "平方米",
          "partitionName": "展示区",
          "massAreaVal": 9500
        }]
      }
      var resultData = data
      for (key in resultData) {
        for (i = 0; i < list.length; i++) {
          if (key === list[i].name) {
            list[i].setList(resultData[key])
            this.datalist.push(resultData[key])
          }
        }
        for (j = 0; j < rightlist.length; j++) {
          if (key === rightlist[j].name) {
            rightlist[j].setList(resultData[key])
            this.datalist.push(resultData[key])
          }
        }
      }
      this.massifList = list
      this.massifListR = rightlist
      console.log(this.datalist)
      this.time()
    }
    console.log(config.fileDomain)
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?fe52a4ca